import React from 'react';
import styled from 'styled-components';

const TimeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const TimeLabel = styled.span`
  color: #FFFFFF;
  font-weight: bold;
  line-height: 1.3;
  font-size: 4vw;
  display: block;
  color: #B9C2C9;
`;

const TimeValue = styled.span`
  font-size: 8vw;
  font-weight: 800;
  color: #FFFFFF;
  display: inline-block;
  text-overflow: clip;
  overflow: hidden;
  white-space: nowrap;
`;

const TimeStat = ({ label, value, styles = {} }) => {
  if (!value) {
    return null;
  }
  
  return (
    <TimeWrapper style={styles.wrapper}>
      <TimeLabel style={styles.label}>{label}</TimeLabel>
      <TimeValue style={styles.value}>{value}</TimeValue>
    </TimeWrapper>
  );
};

export default TimeStat;
